import React from 'react';
import { useGuides } from './GuidesContext.jsx';

/* SectionCard — titled section wrapper. Subtitle rendering is gated by
   Settings → Guide Controls → "Section subtitles". When off, the
   <p> descriptive line disappears for a denser header. */
export default function SectionCard({ title, subtitle, children, right, accent, sectionId, id }) {
  const { subtitles } = useGuides();
  const anchorId = id || (sectionId ? `section-${sectionId}` : undefined);
  const showSubtitle = subtitles && !!subtitle;
  return (
    <section
      id={anchorId}
      data-section-id={sectionId}
      className="bg-surface border border-border rounded-[10px] mb-4 shadow-sm min-w-0"
      style={accent ? { borderLeft: `3px solid ${accent}` } : undefined}
    >
      {(title || right) && (
        <header className="flex justify-between items-start gap-[0.8rem] px-[1.15rem] pt-[0.9rem] pb-[0.3rem] border-b border-border min-w-0">
          <div className="min-w-0">
            {title && <h3 className="text-base font-semibold text-text tracking-[-0.01em] m-0">{title}</h3>}
            {showSubtitle && <p className="text-[0.8rem] text-text-muted mt-[0.2rem] mb-0">{subtitle}</p>}
          </div>
          {right && <div className="flex gap-[0.4rem] items-center">{right}</div>}
        </header>
      )}
      <div className="px-[1.15rem] pt-[0.9rem] pb-4 min-w-0">{children}</div>
    </section>
  );
}
